/**
 * StylingButton.tsx — Button component for triggering styling
 *
 * Displays a primary button with loading state and spinner.
 */

import React from "react";
import { Button, Spinner, tokens } from "@fluentui/react-components";
import "./StylingButton.css";

interface StylingButtonProps {
  onClick: () => void;
  isLoading: boolean;
  disabled?: boolean;
}

export const StylingButton: React.FC<StylingButtonProps> = ({
  onClick,
  isLoading,
  disabled = false,
}) => {
  return (
    <Button appearance="primary" size="large" onClick={onClick} disabled={isLoading || disabled}>
      {isLoading ? (
        <>
          <Spinner size="tiny" style={{ marginRight: tokens.spacingHorizontalXS }} />
          Processing...
        </>
      ) : (
        "Run Styling Assistant"
      )}
    </Button>
  );
};
